export default __webpack_public_path__ + "static/media/Flow of the Sword.5a27cbad.png";